<template>
  <x-page title="选择定位">
    <div :class="_.page">
      <div :class="_.hd">
        <div :class="_.search">
          <img src="./images/搜索.png" :class="_.icon" />
          <!-- <XSearch
              v-model="tempKeyword"
              :class="_.input"
              placeholder="输入地点关键词搜索"
              @search="() => (keyword = tempKeyword)"
            /> -->
          <input
            v-model="tempKeyword"
            :class="_.input"
            type="text"
            placeholder="输入地点关键词搜索"
            @blur="() => (keyword = tempKeyword)"
          />
        </div>
      </div>
      <baidu-map
        :class="_.map"
        :ak="ak"
        :center="$route.query.city || '贵阳'"
        :zoom="15"
        @ready="handler"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
        <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          show-address-bar
          auto-location
        />
        <bm-local-search
          :keyword="keyword"
          :class="_.list"
          :auto-viewport="true"
          @searchcomplete="res => handle('地图搜索结果', res)"
        ></bm-local-search>
      </baidu-map>
      <div :class="_.result">
        <div :class="_.list">
          <XEmpty
            v-if="!result.length"
            :message="keyword ? '暂未找到相关地点' : '请输入地点关键词搜索'"
          />
          <template v-else>
            <div
              v-for="item in result"
              :key="item"
              :class="_.item"
              @click="handle('选择地点', item)"
            >
              <div :class="_.content">
                <div :class="_.title">{{ item.title }}</div>
                <div :class="_.desc">{{ item.address }}</div>
              </div>
              <img src="./images/未选中.png" :class="_.radio" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    BaiduMap,
    BmGeolocation,
    // BmView,
    BmLocalSearch,
    BmNavigation,
  } from 'vue-baidu-map'
  import { navigateBack } from '@/router'
  export default Vue.extend({
    noKeepalive: true,
    components: {
      BaiduMap,
      BmGeolocation,
      // BmView,
      BmLocalSearch,
      BmNavigation,
    },
    data: () => ({
      loading: true,

      ak: process.env.VUE_APP_BASE_AK,

      keyword: '',
      tempKeyword: '',
      result: [],
      currentAddress: {},
    }),

    methods: {
      handler({ BMap, map }) {
        console.log(BMap, map)
        // this.map.center.lng = 116.404
        // this.map.center.lat = 39.915
        // this.map.zoom = 15
      },
      handle(type, res) {
        switch (type) {
          case '地图搜索结果':
            if (res) {
              console.log(res)
              this.result = res.as
            }
            break
          case '选择地点':
            this.currentAddress = {
              longitude: res.point.lng,
              latitude: res.point.lat,
              address: res.address,
            }

            this.$eventBus.emit('setStreet', res.address)
            navigateBack()
            console.log(this.currentAddress)
            break
          default:
            // default code
            break
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .hd {
      flex-shrink: 0;
      height: 44px;
      background: #ffffff;
      padding: 0 12px;
      display: flex;
      align-items: center;

      .search {
        flex-grow: 1;
        height: 34px;
        background: #f5f5f5;
        border-radius: 17px;
        display: flex;
        align-items: center;
        padding: 0 12px;

        .icon {
          width: 16px;
          height: 16px;
        }

        .input {
          margin-left: 7px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333;
          line-height: 20px;
          font-style: normal;
          border: none;
          outline: none;
          border-radius: 0;
          box-shadow: none;
          appearance: none;
          background-color: transparent;

          &::placeholder {
            color: #999;
          }
        }
      }
    }

    .map {
      width: 100%;
      height: 300px;
      :global {
        a[title='到百度地图查看此区域'] {
          display: none;
        }
      }
      .list {
        opacity: 0;
        pointer-events: none;
      }
    }
    .result {
      flex-grow: 1;
      height: 100%;
      overflow: auto;
      background: #ffffff;
      border-radius: 12px 12px 0px 0px;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      box-sizing: border-box;

      .list {
        padding: 0 16px;

        .item {
          padding: 12px 0;
          display: flex;
          align-items: center;

          .content {
            flex-grow: 1;

            .title {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 15px;
              color: #333333;
              line-height: 21px;
              font-style: normal;
            }

            .desc {
              margin-top: 4px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              font-style: normal;
            }
          }

          .radio {
            margin-left: 12px;
            flex-shrink: 0;
            width: 18px;
            height: 18px;
          }

          + .item {
            --hairlineColor: #eaeaea;
            --hairlineRadius: 0;
            position: relative;

            &::after {
              position: absolute;
              box-sizing: border-box;
              transform-origin: center;
              content: ' ';
              pointer-events: none;
              z-index: 1;

              top: -50%;
              right: -50%;
              bottom: -50%;
              left: -50%;
              border: 0 solid var(--hairlineColor);
              border-radius: var(--hairlineRadius);
              transform: scale(0.5);

              // prettier-ignore
              border-top-width: 1PX;
            }
          }
        }
      }
    }
  }
</style>
